import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';

import './plugins/bootstrap-vue';
import './plugins/vue-fontawesome';
//import * as firebase from 'firebase';
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import moment from 'moment';

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
// initialize firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const storage = firebase.storage();
export const db = firebase.firestore();
// export types that exists in Firestore
const { TimeStamp, GeoPoint } = firebase.firestore;
export { TimeStamp, GeoPoint };

let app;

// firebase observer to fetch the user
firebase.auth().onAuthStateChanged(async user => {
  await store.dispatch('auth/fetchUser', user);

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});

Vue.filter('formatDate', value => {
  if (value) {
    return moment(String(value)).format('ddd YYYY-MM-DD HH:mm');
  }
});
